<template>
  <v-dialog v-model="showDialog" max-width="1300" scrollable persistent>
    <v-card>
      <v-card-title class="secondary white--text px-4 py-2">
        <span>Manage Charges</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <v-row class="ma-0" v-if="!readonly">
          <v-col cols="12" lg="4" class="Form-Columns-Dense">
            <MultiSelect
              label="Select Charge"
              :items="allCharges"
              itemText="charge_title"
              itemValue="id"
              :returnObject="true"
              hide-details="auto"
              v-model="newCharge.charge"
              @input="setChargeDetails"
            />
          </v-col>
          <v-col cols="12" lg="4" class="Form-Columns-Dense">
            <InputField
              label="Description"
              readonly
              :clearable="false"
              hide-details="auto"
              v-model="newCharge.description"
            />
          </v-col>
          <v-col cols="12" lg="1" class="Form-Columns-Dense">
            <InputField
              label="Cost GL No."
              readonly
              :clearable="false"
              hide-details="auto"
              v-model="newCharge.cost_gl_no"
            />
          </v-col>
          <v-col cols="12" lg="1" class="Form-Columns-Dense">
            <InputField
              type="number"
              label="TAX (%)"
              readonly
              :clearable="false"
              hide-details="auto"
              v-model="newCharge.tax_percentage"
            />
          </v-col>
          <v-col cols="12" lg="1" class="Form-Columns-Dense d-flex align-center">
            <InputField
              type="number"
              :label="`Rate (${$globals.currency}) *`"
              :disabled="!newCharge.charge"
              hide-details="auto"
              v-model="newCharge.rate"
            />
          </v-col>
          <v-col cols="12" lg="1" class="Form-Columns-Dense d-flex align-center justify-end">
            <v-btn
              color="primary"
              small
              depressed
              :disabled="!newCharge.charge || !newCharge.rate"
              @click="addCharge"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="ma-0 mt-2">
          <v-col cols="12" class="Form-Columns-Dense">
            <span class="text-h6 font-weight-regular">Charges</span>
          </v-col>
          <v-col cols="12" class="Form-Columns-Dense px-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <AgGridVue
          style="width: 100%; height: 40vh"
          class="ag-theme-alpine mt-2"
          id="manageChargesGrid"
          :columnDefs="headers"
          :context="context"
          :defaultColDef="defaultColDef"
          :grid-options="gridOptions"
          :rowData="localCharges"
        ></AgGridVue>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary" depressed @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import { AgGridVue } from "ag-grid-vue";
import chargesRemoveButton from "@/components/AgGridComponents/chargesRemoveButton.vue";

export default {
  components: {
    InputField,
    MultiSelect,
    AgGridVue,
    chargesRemoveButton,
  },

  props: {
    value: { type: Boolean, default: false },
    charges: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },

  data() {
    return {
      localCharges: [],
      allCharges: [],
      newCharge: {},

      headers: [
        { headerName: "Charge", field: "charge_title", minWidth: 150 },
        { headerName: "Description", field: "description", minWidth: 180 },
        { headerName: "Cost GL No.", field: "cost_gl_no", minWidth: 120 },
        { headerName: "Tax (%)", field: "tax_percentage", minWidth: 90 },
        { headerName: "Rate", field: "rate", minWidth: 100 },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "chargesRemoveButton",
          pinned: "right",
          width: 90,
        },
      ],
      defaultColDef: { resizable: true, flex: 1 },
      gridOptions: {
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
    };
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    context() {
      return { parentComponent: this };
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.localCharges = JSON.parse(JSON.stringify(this.charges || []));
        this.newCharge = {};
        this.getCharges();
      }
    },
  },

  methods: {
    closeDialog() {
      this.showDialog = false;
    },

    getCharges() {
      this.$bus.$emit("showLoader", true);
      this.$api.charge
        .getChargeList({ limit: "all", is_active: "true" })
        .then((res) => {
          this.allCharges = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch(() => {
          this.$bus.$emit("showLoader", false);
        });
    },

    setChargeDetails(val) {
      if (val) {
        this.newCharge = {
          charge: val.id,
          charge_title: val.charge_title,
          cost_gl_no: val.cost_gl_no,
          description: val.description,
          rate: val.rate,
          tax_percentage: val.tax_percentage,
        };
      } else {
        this.newCharge = {};
      }
    },

    addCharge() {
      this.localCharges.push(this.newCharge);
      this.newCharge = {};
    },

    removeCharges(index) {
      this.localCharges.splice(index, 1);
    },

    save() {
      this.$emit("save", this.localCharges);
      this.showDialog = false;
    },
  },
};
</script>
